// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3753":"0e4a0c32","6716":"7eaec8ea"}[chunkId] + ".chunk.css";
};